var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"is-size-5",attrs:{"to":_vm.route},nativeOn:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"slideout-navbar-item"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75d2d662","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/NavigationItem.vue
// module id = null
// module chunks = 